import styled from 'styled-components'

export default styled.input.attrs(props => ({
  type: 'file',
  text: props.text || 'Select File',
}))`
  text-shadow: none;
  border: 0;
  cursor: pointer;

  ::before {
    content: '${props => props.text}';
    display: inline-block;
    outline: none;
    white-space: nowrap;
    -webkit-user-select: none;
    cursor: pointer;
    padding: 0.5em;
    ${({ theme }) => theme.button.default}
  }

  ::-webkit-file-upload-button {
    visibility: hidden;
  }

  &:focus {
    outline: none;
  }
`
